import { ApplicationState } from "..";
import { query } from '../api';
import { Anagrafica, Moduli, Tenant } from "./models";

export const getTenant = (
    state: ApplicationState
): Promise<Tenant> => {
    const url: string = process.env.REACT_APP_TENANT_INFO as string;
    const splittedLocation = window.location.hostname.split(".");
    const tenantName = splittedLocation[0];
    
    return query<Tenant>(url, state, { tenantName }, "default");
}

export const getAnagrafiche = (
    state: ApplicationState,
    refreshCache: boolean
): Promise<Anagrafica[]> => {
    const url: string = '/api/anagrafiche';
    const requestCache: RequestCache = refreshCache ? "reload" : "default";
    
    return query<Anagrafica[]>(url, state, { }, requestCache);
}

export const getModuli = (
    state: ApplicationState
): Promise<Moduli> => {
    const url: string = '/api/moduli';
    
    return query<Moduli>(url, state, { }, 'default');
}